
export const title = (str: string) => {
	const pattern = /\w[^\s-]*/g;

	str = str.replace(pattern, (s) =>
		s.charAt(0).toUpperCase() +
		s.substr(1).toLowerCase(),
	);

	return str;
};
